// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yt-card {
  position: relative;
  cursor: pointer;
  width: 100%;
}
@media (min-width: 769px) {
  .yt-card {
    min-width: 356px;
    min-height: 200px;
  }
}

.yt-card-inner {
  border-radius: 16px;
  overflow: hidden;
  background: #121212;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.yt-card-inner:hover {
  transform: translateY(-2px) scale(1.02);
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.6);
}

.yt-thumb-wrapper {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  background: #000;
}

/* smooth transition on image load */
.yt-thumb-image {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  opacity: 0;
  transition: opacity 0.3s ease, transform 0.25s ease;
}
.yt-thumb-image.loaded {
  opacity: 1;
}

.yt-thumb-overlay {
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at center, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.7));
  opacity: 0;
  transition: opacity 0.25s ease;
}

.yt-card-inner:hover .yt-thumb-overlay {
  opacity: 1;
}

.yt-card {
  -webkit-tap-highlight-color: transparent;
}

.yt-play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 64px;
  height: 64px;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  transition: transform 0.25s ease, background 0.25s ease;
  -webkit-tap-highlight-color: transparent;
}
.yt-play-icon .play-glyph {
  width: 20px;
  height: 41px;
  margin-left: 7px;
}

.yt-card-inner:hover .yt-play-icon {
  transform: translate(-50%, -50%) scale(1.05);
  background: rgba(75, 63, 94, 0.9);
}

.yt-thumb-wrapper iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
  opacity: 0;
  animation: yt-fade-in 0.3s ease forwards;
}

/* react-youtube renders a wrapper <div> with explicit width/height attrs;
   force it to be absolutely positioned so it never adds height to the flow. */
.yt-thumb-wrapper .yt-fill {
  position: absolute !important;
  inset: 0 !important;
  width: 100% !important;
  height: 100% !important;
  padding-bottom: 0 !important; /* cancel the aspect-ratio trick on the inner embed */
}

.yt-thumb-wrapper .yt-fill > div {
  position: absolute !important;
  inset: 0 !important;
  width: 100% !important;
  height: 100% !important;
}

@keyframes yt-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.yt-consent-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.yt-consent-modal {
  width: min(490px, 100% - 32px);
  background: #1b1b1f;
  color: #ffffff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.45);
  text-align: center;
}

.yt-consent-modal h3 {
  margin: 0 0 25px;
  font-size: 24px;
}

.yt-consent-modal p {
  margin: 0 0 25px;
  line-height: 1.2;
  font-size: 15px;
  color: #e7e7e7;
}

.yt-consent-actions {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 10px;
  flex-wrap: wrap;
}

.yt-consent-btn {
  border: 0;
  border-radius: 10px;
  padding: 11px 18px;
  font-size: 15px;
  cursor: pointer;
}

.yt-consent-btn-primary {
  background: #6f5ea8;
  color: #ffffff;
}

.yt-consent-btn-secondary {
  background: #d9d9d9;
  color: #111111;
}

@media (max-width: 768px) {
  .yt-card {
    width: 100%;
  }
  .yt-thumb-wrapper {
    padding-bottom: 100%;
  }
  .yt-thumb-image {
    transform: scale(1.12);
    transform-origin: center;
  }
  .yt-play-icon {
    width: 36px;
    height: 36px;
  }
  .yt-play-icon .play-glyph {
    width: 12px;
    height: 22px;
    margin-left: 3px;
  }
}
.yt-card-spinner-container {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #111111;
  z-index: 5;
}

.yt-card-spinner {
  width: 28px;
  height: 28px;
  border: 3px solid rgba(255, 255, 255, 0.12);
  border-top-color: #f8f8f8;
  border-radius: 50%;
  animation: yt-spin 0.85s linear infinite;
}

@keyframes yt-spin {
  to {
    transform: rotate(360deg);
  }
}
.yt-channel-flag {
  position: absolute;
  top: 8px;
  right: 8px;
  background: rgba(0, 0, 0, 0.65);
  color: #ffffff;
  padding: 4px 6px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.5px;
  line-height: 1;
  z-index: 10;
  -webkit-user-select: none;
          user-select: none;
}

.yt-metadata-overlay {
  position: absolute;
  top: 0;
  right: 0;
  max-width: 48%;
  background: rgba(0, 0, 0, 0.72);
  color: #ffffff;
  padding: 4px 9px;
  border-radius: 10px 0 0 10px;
  font-size: 11px;
  display: flex;
  align-items: center;
  gap: 6px;
  z-index: 10;
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  backdrop-filter: blur(4px);
}

.yt-channel-name {
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (max-width: 768px) {
  .yt-metadata-overlay {
    top: 0 !important;
    right: 0 !important;
    max-width: 68% !important;
    padding: 3px 7px !important;
    border-radius: 9px 0 0 9px !important;
    font-size: 10px !important;
    background: rgba(0, 0, 0, 0.72) !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/YouTubeCard/YouTubeCard.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,eAAA;EACA,WAAA;AACF;AAAE;EAJF;IAKI,gBAAA;IACA,iBAAA;EAGF;AACF;;AAAA;EACE,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uDAAA;AAGF;;AAAA;EACE,uCAAA;EACA,0CAAA;AAGF;;AAAA;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;AAGF;;AAAA,oCAAA;AACA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;EACA,mDAAA;AAGF;AADE;EACE,UAAA;AAGJ;;AACA;EACE,kBAAA;EACA,QAAA;EACA,qFAAA;EACA,UAAA;EACA,8BAAA;AAEF;;AACA;EACE,UAAA;AAEF;;AACA;EACE,wCAAA;AAEF;;AACA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,uDAAA;EACA,wCAAA;AAEF;AAAE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;AAEJ;;AAEA;EACE,4CAAA;EACA,iCAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,cAAA;EACA,UAAA;EACA,wCAAA;AACF;;AAEA;8EAAA;AAEA;EACE,6BAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,4BAAA,EAAA,qDAAA;AACF;;AAEA;EACE,6BAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;AACF;;AAEA;EACE;IACE,UAAA;EACF;EACA;IACE,UAAA;EACF;AACF;AAEA;EACE,eAAA;EACA,QAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAAF;;AAGA;EACE,8BAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,2CAAA;EACA,kBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,eAAA;AAAF;;AAGA;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAAF;;AAGA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;AAAF;;AAGA;EACE,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AAAF;;AAGA;EACE,mBAAA;EACA,cAAA;AAAF;;AAGA;EACE,mBAAA;EACA,cAAA;AAAF;;AAGA;EACE;IACE,WAAA;EAAF;EAGA;IACE,oBAAA;EADF;EAIA;IACE,sBAAA;IACA,wBAAA;EAFF;EAKA;IACE,WAAA;IACA,YAAA;EAHF;EAKE;IACE,WAAA;IACA,YAAA;IACA,gBAAA;EAHJ;AACF;AAQA;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AANF;;AASA;EACE,WAAA;EACA,YAAA;EACA,2CAAA;EACA,yBAAA;EACA,kBAAA;EACA,wCAAA;AANF;;AASA;EACE;IACE,yBAAA;EANF;AACF;AAQA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,+BAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;UAAA,iBAAA;AANF;;AASA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,cAAA;EACA,+BAAA;EACA,cAAA;EACA,gBAAA;EACA,4BAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,0BAAA;AANF;;AASA;EACE,gBAAA;EACA,gBAAA;EACA,uBAAA;AANF;;AAUA;EACE;IACE,iBAAA;IACA,mBAAA;IACA,yBAAA;IACA,2BAAA;IACA,qCAAA;IACA,0BAAA;IACA,0CAAA;EAPF;AACF","sourcesContent":[".yt-card {\n  position: relative;\n  cursor: pointer;\n  width: 100%;\n  @media (min-width: 769px) {\n    min-width: 356px;\n    min-height: 200px;\n  }\n}\n\n.yt-card-inner {\n  border-radius: 16px;\n  overflow: hidden;\n  background: #121212;\n  transition: transform 0.25s ease, box-shadow 0.25s ease;\n}\n\n.yt-card-inner:hover {\n  transform: translateY(-2px) scale(1.02);\n  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.6);\n}\n\n.yt-thumb-wrapper {\n  position: relative;\n  width: 100%;\n  padding-bottom: 56.25%;\n  background: #000;\n}\n\n/* smooth transition on image load */\n.yt-thumb-image {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n  opacity: 0;\n  transition: opacity 0.3s ease, transform 0.25s ease;\n\n  &.loaded {\n    opacity: 1;\n  }\n}\n\n.yt-thumb-overlay {\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(circle at center, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.7));\n  opacity: 0;\n  transition: opacity 0.25s ease;\n}\n\n.yt-card-inner:hover .yt-thumb-overlay {\n  opacity: 1;\n}\n\n.yt-card {\n  -webkit-tap-highlight-color: transparent;\n}\n\n.yt-play-icon {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 64px;\n  height: 64px;\n  border-radius: 999px;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #ffffff;\n  transition: transform 0.25s ease, background 0.25s ease;\n  -webkit-tap-highlight-color: transparent;\n\n  .play-glyph {\n    width: 20px;\n    height: 41px;\n    margin-left: 7px;\n  }\n}\n\n.yt-card-inner:hover .yt-play-icon {\n  transform: translate(-50%, -50%) scale(1.05);\n  background: rgba(75, 63, 94, 0.9);\n}\n\n.yt-thumb-wrapper iframe {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  border: 0;\n  display: block;\n  opacity: 0;\n  animation: yt-fade-in 0.3s ease forwards;\n}\n\n/* react-youtube renders a wrapper <div> with explicit width/height attrs;\n   force it to be absolutely positioned so it never adds height to the flow. */\n.yt-thumb-wrapper .yt-fill {\n  position: absolute !important;\n  inset: 0 !important;\n  width: 100% !important;\n  height: 100% !important;\n  padding-bottom: 0 !important; /* cancel the aspect-ratio trick on the inner embed */\n}\n\n.yt-thumb-wrapper .yt-fill > div {\n  position: absolute !important;\n  inset: 0 !important;\n  width: 100% !important;\n  height: 100% !important;\n}\n\n@keyframes yt-fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.yt-consent-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n.yt-consent-modal {\n  width: min(490px, calc(100% - 32px));\n  background: #1b1b1f;\n  color: #ffffff;\n  border-radius: 16px;\n  padding: 24px;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.45);\n  text-align: center;\n}\n\n.yt-consent-modal h3 {\n  margin: 0 0 25px;\n  font-size: 24px;\n}\n\n.yt-consent-modal p {\n  margin: 0 0 25px;\n  line-height: 1.2;\n  font-size: 15px;\n  color: #e7e7e7;\n}\n\n.yt-consent-actions {\n  display: flex;\n  justify-content: center;\n  gap: 12px;\n  margin-top: 10px;\n  flex-wrap: wrap;\n}\n\n.yt-consent-btn {\n  border: 0;\n  border-radius: 10px;\n  padding: 11px 18px;\n  font-size: 15px;\n  cursor: pointer;\n}\n\n.yt-consent-btn-primary {\n  background: #6f5ea8;\n  color: #ffffff;\n}\n\n.yt-consent-btn-secondary {\n  background: #d9d9d9;\n  color: #111111;\n}\n\n@media (max-width: 768px) {\n  .yt-card {\n    width: 100%;\n  }\n\n  .yt-thumb-wrapper {\n    padding-bottom: 100%;\n  }\n\n  .yt-thumb-image {\n    transform: scale(1.12);\n    transform-origin: center;\n  }\n\n  .yt-play-icon {\n    width: 36px;\n    height: 36px;\n\n    .play-glyph {\n      width: 12px;\n      height: 22px;\n      margin-left: 3px;\n    }\n  }\n\n}\n\n.yt-card-spinner-container {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #111111;\n  z-index: 5;\n}\n\n.yt-card-spinner {\n  width: 28px;\n  height: 28px;\n  border: 3px solid rgba(255, 255, 255, 0.12);\n  border-top-color: #f8f8f8;\n  border-radius: 50%;\n  animation: yt-spin 0.85s linear infinite;\n}\n\n@keyframes yt-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n.yt-channel-flag {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  background: rgba(0, 0, 0, 0.65);\n  color: #ffffff;\n  padding: 4px 6px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  line-height: 1;\n  z-index: 10;\n  user-select: none;\n}\n\n.yt-metadata-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  max-width: 48%;\n  background: rgba(0, 0, 0, 0.72);\n  color: #ffffff;\n  padding: 4px 9px;\n  border-radius: 10px 0 0 10px;\n  font-size: 11px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  z-index: 10;\n  user-select: none;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  backdrop-filter: blur(4px);\n}\n\n.yt-channel-name {\n  font-weight: 600;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n\n@media (max-width: 768px) {\n  .yt-metadata-overlay {\n    top: 0 !important;\n    right: 0 !important;\n    max-width: 68% !important;\n    padding: 3px 7px !important;\n    border-radius: 9px 0 0 9px !important;\n    font-size: 10px !important;\n    background: rgba(0, 0, 0, 0.72) !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
